/**
 * การเล็งและระยะของสกิล
 *
 * แยกออกมาเป็น pure function เพื่อให้เทสต์ได้โดยไม่ต้องมีฉาก กล้อง หรือห้อง
 * ที่นี่ไม่ตัดสินอะไรแทน server — server ยังเป็นคนบอกว่าร่ายได้จริงไหม (`checkCast`)
 * ตรงนี้แค่ช่วยให้ client รู้ว่า "ต้องเดินเข้าไปอีกไหม" และ "ควรหยุดตรงไหน"
 */

/**
 * ยอมปล่อยสกิลเมื่อเข้าใกล้กว่าระยะจริงเล็กน้อย
 *
 * server เผื่อระยะให้ 0.6 หน่วย (`RANGE_SLACK`) อยู่แล้ว การเผื่อฝั่ง client
 * ให้แคบกว่านั้นจึงปลอดภัย: เดินเข้าไปเกินพอดีนิดหน่อยดีกว่าส่งคำสั่งตอนปริ่ม ๆ
 * แล้วโดนปฏิเสธเพราะ server เห็นตำแหน่งเก่ากว่าเราหนึ่ง tick
 */
export const RANGE_MARGIN = 0.4;

/** ใกล้พอจะปล่อยสกิลได้แล้วหรือยัง */
export function inCastRange(distance: number, range: number, margin = RANGE_MARGIN): boolean {
  return distance <= range - margin;
}

export interface Point {
  x: number;
  z: number;
}

/**
 * จุดที่ควรเดินไปเพื่อให้เข้าระยะสกิล
 *
 * เล็งจุดที่อยู่ "ในระยะพอดี" บนเส้นตรงระหว่างเรากับเป้า ไม่ใช่ตัวเป้าเอง
 * ไม่งั้นสายยิงไกลจะเดินทะลุเข้าไปติดตัวมอนทั้งที่ยิงได้ตั้งแต่ไกลแล้ว
 *
 * ถ้าอยู่ในระยะอยู่แล้วก็คืนตำแหน่งเดิม ไม่ต้องขยับ
 */
export function approachPoint(
  from: Point,
  to: Point,
  range: number,
  margin = RANGE_MARGIN,
): Point {
  const dx = to.x - from.x;
  const dz = to.z - from.z;
  const d = Math.hypot(dx, dz);

  if (d === 0 || inCastRange(d, range, margin)) return { x: from.x, z: from.z };

  // หยุดก่อนถึงขอบระยะเล็กน้อย เผื่อเป้าขยับออกระหว่างที่เราเดิน
  // และกันหยุดชิดตัวเกินไปจนสายประชิดยืนซ้อนกับมอน
  const stop = Math.max(0.8, range - margin * 2);
  const k = (d - stop) / d;
  return { x: from.x + dx * k, z: from.z + dz * k };
}
